module.exports = __webpack_public_path__ + "img/mixedmartialarts.a56ce666.svg";